import { ThemeType } from "../theme";

export type ColorType = keyof ThemeType["colors"];

export const themeColor =
  (color: ColorType) =>
  ({ theme }: { theme: ThemeType }) =>
    theme.colors[color];
